import { createSlice } from "@reduxjs/toolkit"

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: null,
    isLoading: false,
    error: null
  },
  reducers: {
    setAuthToken: (state, action) => {
      state.token = action.payload
      state.error = null
    },
    clearAuthToken: state => {
      state.token = null
    },
    setAuthError: (state, action) => {
      state.error = action.payload
    }
  }
})

export const { setAuthToken, clearAuthToken, setAuthError } = authSlice.actions
export const selectAuthToken = state => state.auth?.token
export default authSlice.reducer
